import { render, staticRenderFns } from "./ChatContainer.vue?vue&type=template&id=7319bdba&scoped=true&"
import script from "./ChatContainer.vue?vue&type=script&lang=js&"
export * from "./ChatContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChatContainer.vue?vue&type=style&index=0&id=7319bdba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319bdba",
  null
  
)

export default component.exports